<template>
  <div>
    <el-switch
      v-model="withLimit"
      active-text="With limit"
      inactive-text="Unlimited"
    />
    <div v-show="withLimit">
      <el-input-number
        v-model="model"
        :min="1000"
        controls-position="left"
        @update:modelValue="update"
      />
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, ref, watch } from 'vue'

export default defineComponent({
  name: 'FlatDealLimit',
  props: {
    modelValue: {
      type: Number,
      default: undefined
    }
  },
  setup(props, context) {
    const withLimit = ref(false)

    const model = ref(props.modelValue)

    const update = (newValue: any) => {
      context.emit('update:modelValue', newValue)
    }

    watch(withLimit, (newValue, _oldValue) => {
      if (newValue === false) {
        context.emit('disable')
      } else {
        context.emit('enable')
      }
    })

    return { update, withLimit, model }
  }
})
</script>

<style lang="scss" scoped>
.el-select {
  width: 100%;
}
</style>
